import type { ThirdPartyResponseRow } from '@risksmart-app/drizzle/src/dto';
import type {
  GetThirdPartiesQuery,
  Third_Party_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetThirdPartiesDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';

type UseGetThirdPartyRegisterArgs = Record<string, never>;

export function mapTrpcThirdPartiesToGraphQL(
  trpcData: ThirdPartyResponseRow[] | undefined
): StrictMappedGraphQLSelection<GetThirdPartiesQuery> | undefined {
  if (!trpcData) {
    return undefined;
  }

  return {
    third_party: trpcData,
  };
}

const useThirdPartyRegisterGraphqlVariables = () => {
  const where = useEntityWhereFilter<Third_Party_Bool_Exp>(
    Parent_Type_Enum.ThirdParty
  );

  return { where };
};

export const useGetThirdPartyRegister = createQueryHook<
  UseGetThirdPartyRegisterArgs,
  ThirdPartyResponseRow[],
  GetThirdPartiesQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.thirdParty.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ third_party: data }),
  graphqlDocument: GetThirdPartiesDocument,
  graphqlVariables: useThirdPartyRegisterGraphqlVariables,
});
